import constants from "./constants";
import appConstants from "../../../../../../appConstants";

const getMoveStatus = ({
  pickupPros,
  deliveryPros,
  returnPros,
  fromTrailer,
  currentDriverRoutes
}) => {
  const { allReturnShipments, allPickedUpShipments, allDeliveryShipments } =
    getShipmentsInTrailer(fromTrailer, currentDriverRoutes);

  // All Pickups and Deliveries
  if (
    pickupPros.length > 0 &&
    pickupPros.length === allPickedUpShipments.length &&
    deliveryPros.length > 0 &&
    deliveryPros.length === allDeliveryShipments.length &&
    returnPros.length === 0
  ) {
    return constants.MOVE_STATUS.ALL_PICKUPS_AND_DELIVERIES;
  }

  // All Pickups and Returns
  if (
    pickupPros.length > 0 &&
    pickupPros.length === allPickedUpShipments.length &&
    returnPros.length > 0 &&
    returnPros.length === allReturnShipments.length &&
    deliveryPros.length === 0
  ) {
    return constants.MOVE_STATUS.ALL_PICKUPS_AND_RETURNS;
  }

  // All Pickups
  if (
    pickupPros.length > 0 &&
    pickupPros.length === allPickedUpShipments.length &&
    deliveryPros.length === 0 &&
    returnPros.length === 0
  ) {
    return constants.MOVE_STATUS.ALL_PICKUPS;
  }

  // All Deliveries
  if (
    deliveryPros.length > 0 &&
    deliveryPros.length === allDeliveryShipments.length &&
    pickupPros.length === 0 &&
    returnPros.length === 0
  ) {
    return constants.MOVE_STATUS.ALL_DELIVERIES;
  }

  // All Returns
  if (
    returnPros.length > 0 &&
    returnPros.length === allReturnShipments.length &&
    deliveryPros.length === 0 &&
    pickupPros.length === 0
  ) {
    return constants.MOVE_STATUS.ALL_RETURNS;
  }

  return constants.MOVE_STATUS.INDIVIDUAL_PRO;
};

const getAllDeliveryShipments = (stops) => {
  const allDeliveryShipments = [];
  stops.forEach((stop) => {
    const stopShipments = stop?.shipments.reduce((shipments, shipment) => {
      if (shipment.isShipmentMovedOut) {
        return shipments;
      }
      return [
        ...shipments,
        {
          shipment,
          stop,
          isChecked: false,
        },
      ];
    }, []);
    stopShipments.length !== 0 && allDeliveryShipments.push(...stopShipments);
  });
  return [...allDeliveryShipments];
};

const isDeliveryShipments = (s) => {
  return (
    s.stop.stopType === appConstants.STOP_TYPE.Delivery &&
    s.stop.isStopCompleted === false &&
    s.shipment?.deliveryCode !== constants.RETURN_DELIVERY_CODE
  );
};

const isPickedUpShipments = (s) => {
  return (
    s.stop.stopType === appConstants.STOP_TYPE.Pickup &&
    s.stop.isStopCompleted === true
  );
};

const isReturnShipments = (s) => {
  return (
    s.stop.stopType === appConstants.STOP_TYPE.Delivery &&
    s.stop.isStopCompleted === true &&
    s.shipment?.deliveryCode === constants.RETURN_DELIVERY_CODE
  );
};

const getShipmentsInTrailer = (fromTrailer, currentDriverRoutes) => {
  const allDeliveryShipments = [];
  const allPickedUpShipments = [];
  const allReturnShipments = [];
  const stops = getStopsInTrailer(fromTrailer, currentDriverRoutes);
  const allShipmentsInRoutes = getAllDeliveryShipments(stops);
  const allValidShipments = allShipmentsInRoutes.filter(
    (s) =>
      isDeliveryShipments(s) || isPickedUpShipments(s) || isReturnShipments(s),
  );

  allValidShipments.forEach((s) => {
    isDeliveryShipments(s) &&
      allDeliveryShipments.push({ ...s, isChecked: true });
    isPickedUpShipments(s) &&
      allPickedUpShipments.push({ ...s, isChecked: true });
    isReturnShipments(s) && allReturnShipments.push({ ...s, isChecked: true });
  });

  const allShipments = [
    ...allDeliveryShipments,
    ...allPickedUpShipments,
    ...allReturnShipments
  ];

  return {
    allShipments,
    allReturnShipments,
    allPickedUpShipments,
    allDeliveryShipments,
    individualSelectedShipments: allValidShipments,
  };
};

const getStopTypeListForPreselectedShipments = () => {
  return [
    constants.STOPS.ALL_STOPS,
    constants.STOPS.ALL_DELIVERIES,
    constants.STOPS.ALL_PICKUPS
  ];
};

const getStopsInTrailer = (fromTrailer, currentDriverRoutes) => {
  return (
    currentDriverRoutes.find(
      (route) =>
        route.trailerId?.toLowerCase() === fromTrailer?.trailerId?.toLowerCase()
    )?.stops ?? []
  );
};

const getTrailerStatusesAllowedToMoveBills = (trailerStatusConfig) => {
  return trailerStatusConfig
    .filter((trailerStatus) => trailerStatus.isMoveBillsAllowed)
    .map((trailerStatus) => trailerStatus.status);
}

const getTrailerStatusesAllowedToHook = (trailerStatusConfig) => {
  return trailerStatusConfig
    .filter((trailerStatus) => trailerStatus.isAllowedToHook)
    .map((trailerStatus) => trailerStatus.status);
}

const getDollyStatusesAllowedToHook = (dollyStatusConfig) => {
  return dollyStatusConfig
    .filter((dollyStatus) => dollyStatus.isAllowedToHook)
    .map((dollyStatus) => dollyStatus.status);
}

export {
  getMoveStatus,
  getShipmentsInTrailer,
  getStopTypeListForPreselectedShipments,
  getTrailerStatusesAllowedToMoveBills,
  getTrailerStatusesAllowedToHook,
  getDollyStatusesAllowedToHook,
};
